// import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/homologations",
    name: "Homologations List",
    meta: { title: "Homologacije" },
    component: () => import(/* webpackChunkName: "Entities List" */ "@/Modules/Homologation/Views/List")
    // beforeEnter: ifAuthenticated
  }
]
